import React from 'react';

function ReviewsTableRowSkeleton() {
  return (
    <tr className="border-b border-border">
      {/* Avatar */}
      <td className="px-3 py-3">
        <div className="h-8 w-8 rounded-full bg-muted animate-pulse" />
      </td>

      {/* Email */}
      <td className="px-3 py-3">
        <div className="h-4 w-32 bg-muted rounded animate-pulse" />
      </td>

      {/* Department */}
      <td className="px-3 py-3">
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </td>

      {/* Review Goal */}
      <td className="px-3 py-3">
        <div className="h-4 w-16 bg-muted rounded animate-pulse" />
      </td>

      {/* Record */}
      <td className="px-3 py-3">
        <div className="h-4 w-12 bg-muted rounded animate-pulse" />
      </td>

      {/* New Goal */}
      <td className="px-3 py-3">
        <div className="h-4 w-16 bg-muted rounded animate-pulse" />
      </td>

      {/* Status */}
      <td className="px-3 py-3">
        <div className="h-5 w-20 bg-muted rounded-full animate-pulse mx-auto" />
      </td>

      {/* Confirmed */}
      <td className="px-3 py-3">
        <div className="h-6 w-8 bg-muted rounded animate-pulse mx-auto" />
      </td>

      {/* Declined */}
      <td className="px-3 py-3">
        <div className="h-6 w-8 bg-muted rounded animate-pulse mx-auto" />
      </td>

      {/* Progress */}
      <td className="px-3 py-3">
        <div className="h-5 w-24 bg-muted rounded animate-pulse mx-auto" />
      </td>

      {/* Review Date */}
      <td className="px-3 py-3">
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </td>

      {/* Expand */}
      <td className="px-3 py-3">
        <div className="h-4 w-4 bg-muted rounded animate-pulse mx-auto" />
      </td>
    </tr>
  );
}

export default ReviewsTableRowSkeleton;
